(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3612],{

/***/ 94514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/cro-agency-london",
      function () {
        return __webpack_require__(89170);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cro_agency_london; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/animation.ts
var animation = __webpack_require__(89428);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var NextLink = __webpack_require__(99472);
// EXTERNAL MODULE: ./src/components/blocks/hero/index.ts + 40 modules
var hero = __webpack_require__(53901);
// EXTERNAL MODULE: ./src/components/reuseable/ContactFooterCombo.tsx
var ContactFooterCombo = __webpack_require__(79266);
;// CONCATENATED MODULE: ./src/data/answer-the-public/cro.ts
var cro = [
    {
        title: "CRO agency London",
        url: ""
    },
    {
        title: "CRO agency UK",
        url: ""
    },
    {
        title: "CRO agency",
        url: ""
    },
    {
        title: "what is a CRO agency",
        url: ""
    },
    {
        title: "top CRO companies UK",
        url: ""
    }
];

// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
// EXTERNAL MODULE: ./src/components/blocks/video/Video.tsx
var Video = __webpack_require__(62920);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
;// CONCATENATED MODULE: ./pages/london/cro-agency-london/index.tsx




// -------- custom component -------- //







var answerThePublic = cro;
var details = {
    pageName: "CRO Agency London",
    categories: "seo, web design",
    description: "MoltoCRO Agency London improve your site ranking with a free technical SEO audit and the highest quality conversion rate optimisation services",
    parentDirectories: ""
};
var croPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(keywords.CRO[0].title),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.CRO[0].url, "/").concat(keywords.CRO[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: (0,animation/* fadeInAnimate */.St)("900ms"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video["default"], {
                                    heading: keywords.CRO[0].title,
                                    title1: "AI",
                                    title2: "CRO",
                                    title3: "",
                                    movie: "/1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: "helps companies vastly improve their conversion rate optimisation with AI-powered CRO. If\xa0you\xa0want to accelerate your business online, we are the experts using proprietary technology and AI."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-lg-7 mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[0].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Are you looking to significantly improve the performance of your website, enhance user experience, and convert a higher percentage of visitors into valuable customers? Look no further than Molto",
                                                    " ",
                                                    keywords.CRO[0].title,
                                                    ", your trusted partner in achieving your digital goals. With a proven track record in Conversion Rate Optimization (CRO), Molto SEO, your",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        title: keywords.HomeList[7].title,
                                                        href: "/"
                                                    }),
                                                    ", is the go-to agency for businesses like yours that are determined to extract the utmost value from their website traffic."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[1].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Molto CRO ",
                                                    keywords.CRO[1].title,
                                                    " takes pride in establishing close partnerships with our clients, recognizing the significance of understanding their unique goals, objectives, and target audience. We believe that effective collaboration is the cornerstone of success in any CRO campaign. By immersing ourselves in your business, we gain valuable insights that allow us to develop tailored strategies meticulously designed to achieve your specific business objectives, no matter how ambitious they may be. At Molto ",
                                                    keywords.CRO[1].title,
                                                    ", we understand that every business is unique, with its own set of challenges and opportunities. Our approach is not one-size-fits-all; rather, we take the time to thoroughly comprehend your industry, competitors, and target market. By delving deep into your business ecosystem, we are equipped with the knowledge needed to craft customized CRO strategies that resonate with your audience, maximize conversions, and drive tangible results."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[2].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Whether your primary objective is to increase sales, generate leads, boost engagement, or achieve a combination of these goals, our comprehensive range of ",
                                                    keywords.CRO[2].title,
                                                    " at Molto CRO agency UK is designed to propel your business towards success."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "At Molto CRO agency UK, we employ a wide array of cutting-edge techniques and tactics to optimize your website for maximum conversions. Our meticulous approach encompasses various strategies, including but not limited to:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "A/B testing: Through rigorous testing, we explore different variations of your website, meticulously analyzing user behavior and engagement metrics to identify the most effective design and content elements. By continuously refining and optimizing your website based on data-driven insights, we ensure that it consistently performs at its peak."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "User experience (UX) optimization: Our team of experts delves deep into your website's design, navigation, and functionality, striving to create an intuitive and user-friendly digital environment. We analyze user flow, identify potential friction points, and implement strategic improvements to enhance the overall user experience, ultimately resulting in higher conversion rates."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Call-to-action (CTA) optimization: A well-crafted and strategically placed call-to-action can make a significant difference in driving user engagement and conversions. Through extensive testing, we determine the most compelling CTAs that encourage clicks and conversions. By optimizing your CTAs, we create a sense of urgency and guide users seamlessly towards desired actions."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Landing page optimization: The landing page is often the first point of contact for potential customers. Our team specializes in optimizing landing pages to ensure they are relevant, engaging, and optimized for conversions. We analyze elements such as headline messaging, visuals, content structure, and overall layout to create a cohesive and persuasive user experience that maximizes conversions."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Cart abandonment recovery: Cart abandonment is a common challenge for e-commerce businesses. We understand the importance of recapturing those lost sales. Our strategies focus on targeting customers who have abandoned their shopping carts, utilizing personalized messaging, compelling incentives, and strategic remarketing techniques to entice them back and complete their purchases."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "When you partner with Molto CRO agency UK, you gain access to an extensive toolkit of",
                                                    " ",
                                                    keywords.CRO[2].title,
                                                    " that are tailored to your unique business needs. We are committed to delivering measurable results and exceeding your expectations, driving your business towards sustainable growth and success. Contact us today to take your conversions to new heights and unlock the full potential of your online presence."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "website-test"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* Hero1 */.lE, {
                                bgcolor: "bg-soft-primary mb-20 pt-20",
                                title: "",
                                lead: "",
                                body: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center",
                                        id: "report",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center fs-34 mb-0 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "GET YOUR FREE ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-fuchsia",
                                                            children: "TECHNICAL SEO REPORT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-center fs-18 mx-auto",
                                                children: [
                                                    "Action the findings from the report or purchase ",
                                                    keywords.HomeList[8].title
                                                ]
                                            })
                                        ]
                                    }, 100)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-lg-7 mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[3].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "As the premier provider of ",
                                                    keywords.CRO[3].title,
                                                    ", Molto CRO agency UK is committed to transparency in all aspects of our work. We firmly believe in establishing open lines of communication with our clients, ensuring that they are fully informed about our strategies, methodologies, and the rationale behind our actions. We value your trust and prioritize honesty throughout our partnership."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "At Molto CRO agency UK, transparency is more than just a buzzword - it's ingrained in our work culture. We provide regular, detailed reports on your website's performance, offering insights into key metrics, conversion rates, user behavior, and the impact of our optimization efforts. These reports enable you to track the progress of your campaigns, make informed decisions, and have a comprehensive understanding of the value we bring to your business."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Moreover, our dedication to transparency goes beyond providing reports. We pride ourselves on being readily available to address any questions, concerns, or inquiries you may have. Our team of experts is always just a call or email away, ensuring that you have direct access to the knowledge and support you need throughout our collaboration. As a leading ",
                                                    keywords.CRO[3].title,
                                                    ", we value the importance of your input and actively seek your feedback to refine our strategies and deliver optimal results."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "When it comes to finding the best conversion rate optimization services in London, look no further than Molto SEO. Our track record of success, commitment to transparency, and client-centric approach make us the go-to agency for businesses seeking exceptional results. We understand that your website is a vital asset, and we are dedicated to unlocking its full potential through our tailored CRO strategies."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[4].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "At Molto ",
                                                    keywords.CRO[4].title,
                                                    " UK, our commitment to excellence goes hand in hand with our dedication to ongoing learning and improvement. We understand that the digital marketing landscape is in a constant state of flux, with new trends, technologies, and techniques emerging regularly. That's why we prioritize staying at the forefront of industry advancements, ensuring that we remain one of the best conversion rate optimization agencies in the UK."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our team of experts is passionate about continuous learning and professional development. We invest time and resources into staying up-to-date with the latest trends and best practices in digital marketing. We actively participate in industry conferences, workshops, and training programs to expand our knowledge and enhance our skills. By staying ahead of the curve, we can bring you innovative strategies and cutting-edge solutions that give your business a competitive edge."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "As a leading",
                                                    keywords.CRO[4].title,
                                                    ", we specialize not only in conversion rate optimization (CRO) but also in search engine optimization (SEO). We understand the symbiotic relationship between SEO and CRO, as both disciplines work in harmony to maximize the impact of your online presence. Our expertise in SEO allows us to optimize your website for search engines, ensuring that it ranks prominently in relevant search results and attracts qualified traffic. In combination with our CRO services, we create a comprehensive strategy that drives targeted traffic and maximizes conversions."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "When you choose Molto CRO agency UK, you gain the advantage of our extensive knowledge and experience in both SEO and CRO. We leverage this expertise to deliver integrated solutions that encompass the entire customer journey, from the initial search to the final conversion. By aligning our strategies with your business objectives, we help you achieve sustainable growth and establish a strong digital footprint."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Trust in Molto CRO agency UK as your partner in success. Our commitment to ongoing learning and our specialization in SEO and CRO make us the ideal choice for businesses seeking exceptional results. Contact us today to unlock the full potential of your online presence and witness the transformative power of our integrated strategies. Together, we will pave the way to success in the dynamic digital landscape."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[5].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "What sets Molto SEO apart from other conversion optimization agencies is our unwavering commitment to providing you with comprehensive solutions that go beyond the standard offerings. As a leading",
                                                    " ",
                                                    keywords.CRO[5].title,
                                                    ", we believe in going the extra mile to deliver exceptional value to our clients. Our approach extends far beyond simply optimizing conversions - we offer you a holistic diagnostic experience coupled with unparalleled customer service."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "When you choose Molto SEO as your ",
                                                    keywords.CRO[5].title,
                                                    ", you can expect a tailored diagnostic that is specifically designed to address your unique business challenges and objectives. We understand that every business is different, with its own set of strengths, weaknesses, and opportunities. Our team of experts conducts a thorough analysis of your website, user journey, and conversion funnels, delving deep into the intricacies of your online presence."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Through our meticulous diagnostic process, we identify areas of improvement, pinpoint conversion barriers, and uncover untapped potential. Our goal is to provide you with actionable insights and data-driven recommendations that empower you to make informed decisions. By understanding the underlying factors that impact your conversions, we can develop tailored strategies that drive meaningful results and maximize your return on investment."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[6].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "At Molto CRO agency UK, we are not just a run-of-the-mill ",
                                                    keywords.CRO[6].title,
                                                    "; we are at the forefront of the industry, leveraging cutting-edge techniques and a data-driven approach to revolutionize your CRO journey. We understand that successful optimization requires more than just intuition and guesswork; it demands a meticulous analysis of data and the ability to derive actionable insights. That's why we rely on advanced analytics and reporting tools to measure the effectiveness of our strategies and make informed, data-driven decisions."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our team of experts is well-versed in utilizing sophisticated analytics platforms to extract valuable information from your website's performance data. We dive deep into the numbers, examining key metrics, user behaviour patterns, and conversion rates to gain a comprehensive understanding of your website's strengths and areas for improvement. By delving into the data, we can identify trends, uncover hidden opportunities, and fine-tune our strategies to deliver optimal results."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Data is the cornerstone of our approach, guiding every step of our CRO process. We conduct thorough A/B tests, multivariate tests, and heat mapping analyses to gather quantitative data on user interactions, engagement, and conversion rates. These tests provide us with valuable insights into the effectiveness of different variations and allow us to make data-driven decisions about which strategies and elements are driving the highest conversions. With a keen focus on data analysis, we continuously refine and optimize our strategies to ensure maximum impact on your bottom line."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "While data is at the heart of our conversion rate optimization efforts, we also recognize the importance of human connection. We believe that providing exceptional customer service is key to delivering a highly satisfying experience for our clients. Our team is dedicated to being responsive, accessible, and proactive in addressing your questions, concerns, and inquiries. We understand the value of open lines of communication and transparent collaboration, ensuring that you are always in the loop and confident in the progress of your CRO campaigns."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "As a cutting-edge ",
                                                    keywords.CRO[6].title,
                                                    ", we are dedicated to offer a highly satisfying experience for our customers."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: keywords.CRO[7].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "As such, we have both the technical and human abilities to give you the best ",
                                                    keywords.CRO[7].title,
                                                    ". Our team of experts is constantly staying up to the latest technologies and updates, ensuring that they get the best possible ",
                                                    keywords.CRO[7].title,
                                                    " and the best return on their investment."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "So, are you ready to take your online presence to the next level? Contact Molto SEO, one of the best",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        title: keywords.EcommerceSEO[0].title,
                                                        href: "/" + keywords.EcommerceSEO[0].url + "/" + keywords.EcommerceSEO[0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    " in the UK, to learn more about how we can help you achieve your digital marketing goals. Check",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        title: keywords.MegaList[1][0].title,
                                                        href: "/" + keywords.MegaList[1][0].url + "/" + keywords.MegaList[1][0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    " ",
                                                    "and ask for a thorough",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        title: keywords.SEOAudit[2].title,
                                                        href: "/" + keywords.SEOAudit[0].url + "/" + keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    " to unlock growth possibilities for your business."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFooterCombo/* default */.Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cro_agency_london = (croPage);


/***/ }),

/***/ 77632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86523);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22546);







// ==================================================================
var Carousel = function(props) {
    var children = props.children, slideClassName = props.slideClassName, _spaceBetween = props.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 30 : _spaceBetween, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 3 : _slidesPerView, _pagination = props.pagination, pagination = _pagination === void 0 ? true : _pagination, _navigation = props.navigation, navigation = _navigation === void 0 ? true : _navigation, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "slideClassName",
        "spaceBetween",
        "slidesPerView",
        "pagination",
        "navigation"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref[0], setPrevEl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
        ],
        navigation: navigation ? {
            prevEl: prevEl,
            nextEl: nextEl
        } : false,
        pagination: pagination ? {
            clickable: true
        } : false
    }, others), {
        children: [
            children.map(function(slide, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                    className: slideClassName,
                    children: slide
                }, i);
            }),
            navigation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "swiper-navigation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setPrevEl(node);
                        },
                        className: "swiper-button swiper-button-prev swiper-button-disabled"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setNextEl(node);
                        },
                        className: "swiper-button swiper-button-next"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 79266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 454).then(__webpack_require__.bind(__webpack_require__, 454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(454)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Drop Us a Line",
                    body: "Reach out to us from our contact form and we will get back to you shortly.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 42744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);





// ====================================================
var FigureImage = function(props) {
    var className = props.className, src = props.src, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "src",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className
    }, others), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            width: width,
            height: height,
            src: src,
            alt: "demo",
            quality: "100"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FigureImage);


/***/ }),

/***/ 79588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
// useLogVisitor.js


var useLogVisitor = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visitor = Array.isArray(router.query.visitor) ? router.query.visitor[0] : router.query.visitor;
        if (visitor) {
            fetch("/.netlify/functions/logVisitor?visitor=".concat(encodeURIComponent(visitor))).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log("Visitor logged:", data.message);
            }).catch(function(error) {
                console.error("Error logging visitor:", error);
            });
        }
    }, [
        router.query.visitor
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogVisitor);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4525,61,4870,4556,9447,9774,2888,179], function() { return __webpack_exec__(94514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);